import React from 'react';
import classnames from 'classnames';
import { DH } from '../../../../utils/dataHooks';
import { HorizontalLayoutDivider } from '../HorizontalLayoutDivider';
import { t } from '../../../../utils/i18n';
import { AllExpressButtons } from '../ExpressButtons';
import { classes } from '../../styles.st.css';

export const HorizontalListView = () => {
  return (
    <>
      <fieldset data-hook={DH.Widget.HorizontalLayoutFieldset} className={classnames(classes.fieldset)}>
        <legend className={classes.legend}>{t('horizontalLayout.header')}</legend>
        <div data-hook={DH.Widget.PMList} className={classnames(classes.layout, classes.horizontal)}>
          <AllExpressButtons />
        </div>
      </fieldset>
      <HorizontalLayoutDivider />
    </>
  );
};
